export default __webpack_public_path__ + "static/media/leticia-neo-soul.4ce2c58b.mp4";